import DomainDisclaimer from "../../../../contents/docs/self-host/deploy/snippets/domain-disclaimer";
import * as React from 'react';
export default {
  DomainDisclaimer,
  React
};